import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { useTranslation } from "react-i18next";
import { keyframes } from "@mui/system";
import ChessButton from "./ChessButton"; // Assuming you have a ChessButton component
import { styled } from "@mui/system";
// 👇 Bouncy animation for coin image
const bounce = keyframes`
  0%   { transform: scale(1); }
  50%  { transform: scale(1.2); }
  100% { transform: scale(1); }
`;

const PriceText = styled(Typography)(({ theme }) => ({
  fontSize: "2rem",
  fontWeight: "bold",
  marginBottom: theme.spacing(2),
}));

export default function BuyCoinsSlider({ coinPackages, handlePackageSelection }) {
  
  const [selectedIndex, setSelectedIndex] = useState(0);

  const packages = coinPackages.filter(pkg => pkg.packageType === "package");

  const marks = packages.map((pkg, index) => ({
    value: index,
    label: (
      <Box display="flex" flexDirection="column" alignItems="center">
        <img src="https://res.cloudinary.com/dnlgtek2a/image/upload/v1743405234/Pictures/coin.png" alt="coin" style={{ width: 24, height: 24 }} />
        <Typography variant="caption">{pkg.coins}</Typography>
      </Box>
    )
  }));

  useEffect(() => {
    if (packages.length > 0) {
      const selectedPkg = packages[selectedIndex];
      handlePackageSelection(selectedPkg.planId, "package", selectedPkg.price, selectedPkg);
    }
  }, [handlePackageSelection, packages, selectedIndex]);

  const handleChange = (_event, newValue) => {
    const index = Array.isArray(newValue) ? newValue[0] : newValue;
    setSelectedIndex(index);
  };

  const selectedPkg = packages[selectedIndex];

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 480,
        mx: "auto",
        textAlign: "center",
        p: 2,
        //border: "1px solid #ccc",
        //borderRadius: "16px",
       
        //boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <Typography variant="h5"  sx={{
            marginTop: "10px",
            fontWeight: "bold",
            color: "white",
            marginBottom: "20px",
          }}>
        {selectedPkg?.name}
      </Typography>

      <Slider
        aria-label="Coin Packages"
        value={selectedIndex}
        step={1}
        marks={marks}
        min={0}
        max={packages.length - 1}
        onChange={handleChange}
        sx={{
          mt: 5,
          "& .MuiSlider-markLabel": {
            mt: 1.5,
            color: "white",
          },
          "& .MuiSlider-thumb": {
            backgroundColor: "gold",
            border: "2px solid black",
          },
          "& .MuiSlider-track": {
            backgroundColor: "gold",
          },
          "& .MuiSlider-rail": {
            backgroundColor: "#ddd",
          },
        }}
      />

      <Box mt={4} sx={{ animation: `${bounce} 0.5s` }}>
        <img
          src="https://res.cloudinary.com/dnlgtek2a/image/upload/v1743405234/Pictures/coin.png"
          alt="coin-large"
          style={{ width: 50, height: 50, marginBottom: 8 }}
        />
        <Typography variant="h6" sx={{ color: "gold", fontSize: "2.6rem" }}>
          {selectedPkg?.coins}
        </Typography>
       
        {/* <PriceText color="primary">
                        ${Number(selectedPkg?.price).toFixed(2)}
                      </PriceText> */}
      </Box>

      <Divider sx={{ width: "80%", my: 3 }} />

      {/* <Box sx={{ display: "flex", justifyContent: "center" }}>
        <ChessButton
          text={t("Buy")}
          size="small"
          primaryColor="gold"
          hoverColor="gold"
          fontColor="black"
        />
      </Box> */}
    </Box>
  );
}
